/*
Raghu  27/10/2022 3075154998 Input Field Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
Rohini    10/28/2022 3075154998 added the properties for the root for accordian
Suresh Peddavoora 11/03/2022 3075154998 Text fields Tab Responsive Fixes
*/
import React, {useEffect, useState, useContext} from 'react';
import {
  TextField,
  Button,
  FormHelperText,
  FormControl,
  Typography,
  Card,
} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {Controller, useForm} from 'react-hook-form';
import DialogBox from '../../../../../components/DialogBox';
import {useDispatch, useSelector} from 'react-redux';
import {
  postAddEnableFileFormat,
  resetToast,
  getLookupData,
} from '../../../../../redux/reducers/EnableFramework/AddEnableFileFormat';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {FILE_FORMATS} from '../../../../../constants/Lookup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

import SearchMediaType from '../../MediaType/SearchMediaType';
import MapMediaTypeBox from './MapMediaTypeBox';
import SearchFilterGroup from './SearchRecordFormat';
import {fetchMediaType} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import {fetchFilterGroup} from '../../../../../redux/reducers/EnableFramework/FilterGroup';
import {
  fetchListOfRecordFormats,
  resetRecordFormatData,
} from '../../../../../redux/reducers/BRE/AddRecordFormat';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import EnableSystemNotes from './EnableSystemNotes';
import {makeStyles} from '@material-ui/core/styles';
import RecordFormatTable from './SearchRecordFormat/RecordFormatTable';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {

      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));

const AddEnableFileForm = ({enableCode, setValue, calledId, setCalledId, dataReset}) => {
  const classes1 = useStyles();
  const {
    isLoading,
    errorMsg,
    successMsg,
    dropDownData,
    addEnableFileFormatStatus,
    addEnableFileFormatData,
  } = useSelector(({addEnableFileFormat}) => addEnableFileFormat);
  const {listOfrecordFormatData} = useSelector(({addRecordFormat}) => addRecordFormat);

  const {mediaTypeData, isLoading: mediaTypeLoading} = useSelector(
    ({addMediaType, is}) => addMediaType,
  );
  const dispatch = useDispatch();
  const [showSearchFilterGroup, setShowSearchFilterGroup] = useState(false);
  const [showSearchMediaType, setshowSearchMediaType] = useState(false);
  const [disableCopy, setDisableCopy] = useState(false);
  const [selectedRows, setSelectedRows] = useState(
    addEnableFileFormatData?.recordFormatList ? addEnableFileFormatData.recordFormatList : [],
  );

  const [selectedFilterGroupCode, setSelectedFilterGroupCode] = useState(
    addEnableFileFormatData?.filterCode,
  );
  const [selectedMediaTypeName, setSelectedMediaTypeName] = useState(
    addEnableFileFormatData?.mediaName,
  );
  const [fileFormatCode, setFileFormatCode] = useState(
    addEnableFileFormatData?.format ? addEnableFileFormatData?.format : '',
  );
  const [expanded, setExpanded] = useState();
  const [refreshNotesTable, setRefreshNotesTable] = useState(false);

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const initialValues = {
    fileFormat: dataReset ?
      '' :
      addEnableFileFormatData?.format ?
        addEnableFileFormatData?.format :
        '',
    fileType: addEnableFileFormatData?.type ? addEnableFileFormatData?.type : '',
    filterGroupCode: selectedFilterGroupCode ? selectedFilterGroupCode : '',
    description: addEnableFileFormatData?.description ? addEnableFileFormatData?.description : '',
    mediaType: selectedMediaTypeName ? selectedMediaTypeName : '',
    matchingLogicExpression: addEnableFileFormatData?.matchingLogicExpression ?
      addEnableFileFormatData?.matchingLogicExpression :
      '',
  };
  const initialValuesEmpty = {
    fileFormat: '',
    fileType: '',
    filterGroupCode: '',
    description: '',
    mediaType: '',
    matchingLogicExpression: '',
  };
  const validationSchema = Yup.object().shape({
    fileFormat: Yup.string().required('File format is required'),
    description: Yup.string().required('Description is required'),
  });
  const {handleSubmit, register, reset, errors, control} = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  useEffect(() => {
    dispatch(getLookupData());
  }, []);

  useEffect(() => {
    Object.keys(addEnableFileFormatData)?.length > 0 && reset(initialValues);
    setFileFormatCode(addEnableFileFormatData?.format && addEnableFileFormatData?.format);
  }, [addEnableFileFormatData]);

  useEffect(() => {
    if (addEnableFileFormatData && addEnableFileFormatData.mediaId) {
      dispatch(fetchMediaType(addEnableFileFormatData?.mediaId));
      setSelectedMediaTypeName(addEnableFileFormatData?.mediaName);
    }
    if (addEnableFileFormatData && addEnableFileFormatData.filterGroupId) {
      dispatch(fetchFilterGroup(addEnableFileFormatData?.filterGroupId));
      setSelectedFilterGroupCode(addEnableFileFormatData?.filterCode);
    }
    if (addEnableFileFormatData && addEnableFileFormatData?.recordFormatList) {
      setSelectedRows(addEnableFileFormatData?.recordFormatList);
    }
  }, [addEnableFileFormatData]);

  const handleAddFilterGroup = () => {
    handleClose();
  };

  const handleClose = () => {
    setshowSearchMediaType(false);
    setShowSearchFilterGroup(false);
    setDisableCopy(false);
  };

  const handleAddMediaType = () => {
    handleClose();
  };
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (addEnableFileFormatStatus === 200) {
      setTimeout(() => {
        setValue(0);
        reset(initialValuesEmpty);
      }, 3000);
    }
    if (addEnableFileFormatStatus) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 2500);
    }
  }, [addEnableFileFormatStatus]);

  useEffect(() => {
    selectedRows.forEach((ele) => {
      if (ele?.id) {
        setCalledId([...calledId, ele.id]);
        dispatch(fetchListOfRecordFormats(ele.id));
      }
    });
  }, [selectedRows]);
  useEffect(
    () => () => {
      dispatch(resetRecordFormatData());
    },
    [],
  );
  const onSubmit = (data) => {
    dispatch(
      postAddEnableFileFormat({
        id: dataReset ? 0 : addEnableFileFormatData?.id ? addEnableFileFormatData?.id : 0,
        description: data.description,
        filterCode: selectedFilterGroupCode ? selectedFilterGroupCode : '',
        format: data.fileFormat,
        mediaName: selectedMediaTypeName ? selectedMediaTypeName : '',
        type: data.fileType,
        matchingLogicExpression: data.matchingLogicExpression,
        recordFormatId:
          selectedRows.length > 0 ? selectedRows.map((ele) => ele.id || ele.recordFormatId) : [],
      }),
    );
  };
  return (
    <div className={`mb-0`}>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
           Search Enable File Format
        </Button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="form-row global-field-textfields">
          <div className="col-sm-6 col-md-4 col-lg-3 form-group">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter File Format"
              margin="dense"
              name="fileFormat"
              variant="outlined"
              label="File Format"
              InputLabelProps={{
                shrink: true,
              }}
              required
              inputRef={register}
              fullWidth
              error={Boolean(errors.fileFormat?.message)}
            />
            <FormHelperText>
              {errors.fileFormat?.message ? errors.fileFormat.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-2 form-group">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{popper: classes.popper, option: classes.option}}
                    {...props}
                    id="fileType"
                    size="small"
                    autoHighlight
                    options={getOptions(FILE_FORMATS, dropDownData).map((option) => option.value)}
                    getOptionDisabled={(option) => option.key === null}
                    renderInput={(params) => (
                      <GuiTextField
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        {...params}
                        variant="outlined"
                        fullWidth
                        label="File Type"
                        name="fileType"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select File Type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="fileType"
                control={control}
              />
            </FormControl>
            <FormHelperText>
              {errors.fileType?.message ? errors.fileType.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Description"
              margin="dense"
              name="description"
              variant="outlined"
              label="Description"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
              required
              error={Boolean(errors.description?.message)}
            />
            <FormHelperText>
              {errors.description?.message ? errors.description.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-4">
            <div className="d-flex align-items-center justify-content-lg-start justify-content-md-end">
              <Button
                variant="outlined"
                className={`search-btn mt-lg-2 mx-1 ${classes.buttonRoot}`}
                onClick={() => {
                  setshowSearchMediaType(true);
                  setDisableCopy(true);
                }}
              >
                Map Media Type
              </Button>
              <FormHelperText>
                {errors.filterGroupCode?.message ? errors.filterGroupCode.message : ''}
              </FormHelperText>
              <Button
                variant="outlined"
                className={`search-btn mt-lg-2 mx-1 ${classes.buttonRoot}`}
                onClick={() => setShowSearchFilterGroup(true)}
              >
                Map Record Format
              </Button>
              <FormHelperText>
                {errors.mediaType?.message ? errors.mediaType.message : ''}
              </FormHelperText>
            </div>
          </div>
          <div className="col-md-8 col-lg-8 form-group mt-3 mt-md-0 ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Matching Logic Expression"
              margin="dense"
              name="matchingLogicExpression"
              variant="outlined"
              label="Matching Logic Expression"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
              minRows={1}
              maxRows={10}
              multiline
            />
          </div>
        </div>
        {mediaTypeData?.id > 0 ? (
          <>
            <div className="my-2">
              <Typography variant="h3">Media Type: </Typography>
            </div>
            <Card className={`${classes.cardBordernoneStyles} mb-3`} style={{borderRadius: '8px'}}>
              <MapMediaTypeBox mediaTypeData={mediaTypeData} />
            </Card>
          </>
        ) : null}
        {selectedRows.length > 0 ? (
          <>
            <div className="mt-1">
              <Typography variant="h3">Record Format</Typography>
            </div>
            {selectedRows.map((recordFormatData, i) => {
              const uniqueListOfrecordFormatData = [
                ...new Map(
                  listOfrecordFormatData?.map((item) => [item['recordFormatId'], item]),
                )?.values(),
              ];

              return (
                <div key={i}>
                  <RecordFormatTable
                    values={uniqueListOfrecordFormatData[i] ? uniqueListOfrecordFormatData[i] : {}}
                    setValue={setValue}
                    formData={
                      uniqueListOfrecordFormatData[i] &&
                      uniqueListOfrecordFormatData[i].members &&
                      uniqueListOfrecordFormatData[i].members.length > 0 ?
                        uniqueListOfrecordFormatData[i].members :
                        []
                    }
                  />
                </div>
              );
            })}
          </>
        ) : null}
        <div>
          <DialogBox
            open={showSearchFilterGroup}
            dialogClose={handleAddFilterGroup}
            title="Add Record Format"
            maxWidth="lg"
          >
            <SearchFilterGroup
              handleClose={handleClose}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              setSelectedFilterGroupCode={setSelectedFilterGroupCode}
            />
          </DialogBox>
        </div>
        <div>
          <DialogBox
            open={showSearchMediaType}
            dialogClose={handleAddMediaType}
            title="Add Media Type"
            maxWidth="lg"
          >
            <SearchMediaType
              handleClose={handleClose}
              setSelectedMediaTypeName={setSelectedMediaTypeName}
              disableCopy={disableCopy}
              setDisableCopy={setDisableCopy}
            />
          </DialogBox>
        </div>
        <div className="d-flex justify-content-center my-3">
          <Button
            variant="outlined"
            onClick={() => {
              reset(initialValues);
            }}
            className={`mx-1 reset-btn ${classes.buttonRoot}`}
          >
            Reset
          </Button>
          <Button
            type="submit"
            variant="outlined"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            disabled={!(mediaTypeData?.id > 0 && selectedRows.length > 0)}
          >
            Save
          </Button>
        </div>
      </form>
      {addEnableFileFormatData?.format && !dataReset && (
        <div className={`${classes1.root} mt-2`}>
          <Accordion
            className="accordion-styling"
            expanded={expanded === 'panel1'}
            onChange={handleAccordionChange('panel1')}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography className={classes1.heading}>Enable File Format Notes</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes1.detailsCard}>
              <EnableSystemNotes
                refreshNotesTable={refreshNotesTable}
                setRefreshNotesTable={setRefreshNotesTable}
                enableCode={enableCode}
                fileFormatCode={fileFormatCode}
              />
            </AccordionDetails>
          </Accordion>
        </div>
      )}
      {isLoading || (mediaTypeLoading && <PageLoader />)}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default AddEnableFileForm;
